/* ============================================================
   LAB EFFECTS — le-variant-cascade.js
   Re-themes a MERGED product page when the shopper switches Plant Source.

   On a merged product the category, COA, SDS and botanical badge live on the
   VARIANT (see snippets/le-variant-source.liquid), not the product — so they
   have to change without a page reload when the source chip changes.

   How it tracks the selection: rather than binding to Horizon's internals, it
   watches the product form's `[name="id"]` input, which every variant picker
   ends up writing to, plus the `?variant=` URL param. That survives Horizon
   upgrades and works with our own chip UI.

   It only ever writes to elements that opt in with a data-le-* hook, so it is
   inert on single-source products and cannot damage a page it doesn't know.
   ============================================================ */
(function () {
  'use strict';

  var island = document.querySelector('script[type="application/json"][data-le-variant-source]');
  if (!island) return;

  var DATA;
  try { DATA = JSON.parse(island.textContent); } catch (e) { return; }
  if (!DATA || !DATA.variants) return;

  var current = null;

  function pick() {
    // 1. the form input every variant picker writes to
    var input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    if (input && input.value && DATA.variants[input.value]) return String(input.value);
    // 2. the URL, for a deep link like ?variant=123
    var q = new URLSearchParams(location.search).get('variant');
    if (q && DATA.variants[q]) return String(q);
    // 3. whatever Liquid rendered
    return DATA.initial != null ? String(DATA.initial) : null;
  }

  function setVar(name, value) {
    if (value) document.documentElement.style.setProperty(name, value);
  }

  function apply(id) {
    var s = DATA.variants[id];
    if (!s || id === current) return;
    current = id;

    /* colour tokens — anything styled with these follows automatically */
    setVar('--le-cat-color', s.color);
    setVar('--le-cat-deep', s.deep);
    setVar('--le-cat-tint', s.tint);
    setVar('--le-cat-soft', s.soft);
    setVar('--le-cat-text', s.text);

    /* opt-in text nodes */
    document.querySelectorAll('[data-le-cat-name]').forEach(function (el) {
      if (s.name) el.textContent = s.name;
    });
    document.querySelectorAll('[data-le-cat-abbr]').forEach(function (el) {
      if (s.abbr) el.textContent = s.abbr;
    });
    document.querySelectorAll('[data-le-cat-swatch]').forEach(function (el) {
      el.style.background = s.tint;
      el.style.color = s.text;
    });

    /* per-source documents */
    document.querySelectorAll('[data-le-coa]').forEach(function (a) { setDoc(a, s.coa); });
    document.querySelectorAll('[data-le-sds]').forEach(function (a) { setDoc(a, s.sds); });

    /* botanical source badge */
    document.querySelectorAll('[data-le-source-img]').forEach(function (im) {
      if (!s.badge) return;
      im.src = s.badge;
      if (s.name) im.alt = s.name + ' botanical source';
      im.removeAttribute('srcset');
    });

    document.dispatchEvent(new CustomEvent('le:source-change', { detail: { variantId: id, source: s } }));
  }

  function setDoc(a, url) {
    if (url) {
      a.setAttribute('href', url);
      a.removeAttribute('aria-disabled');
      a.classList.remove('is-missing');
    } else {
      a.setAttribute('href', '#');
      a.setAttribute('aria-disabled', 'true');
      a.classList.add('is-missing');
    }
  }

  function sync() { var id = pick(); if (id) apply(id); }

  function boot() {
    sync();

    // Variant pickers write the id into the form input; catch every route to it.
    document.addEventListener('change', function (e) {
      if (e.target && e.target.closest && e.target.closest('form[action*="/cart/add"]')) sync();
    }, true);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('[data-le-source-chip]')) setTimeout(sync, 0);
    }, true);

    // Horizon swaps the input node itself on some updates — watch the subtree.
    var form = document.querySelector('form[action*="/cart/add"]');
    if (form && window.MutationObserver) {
      new MutationObserver(function () { sync(); })
        .observe(form, { subtree: true, childList: true, attributes: true, attributeFilter: ['value'] });
    }

    window.addEventListener('popstate', sync);
    ['variant:update', 'variantChange', 'variant:change'].forEach(function (evt) {
      document.addEventListener(evt, sync);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
